<template>
  <div>
    <div class="page_title flex_between">
      <span>
        <span>药品审核详情</span>
        <span
          style="background-color: #ffecda; color: #f48a15"
          class="status"
          v-if="detail.reviewed_status == 1"
          >待审核</span
        >
        <span
          style="background-color: #e5f1e3; color: #669961"
          class="status"
          v-if="detail.reviewed_status == 2"
          >审核通过</span
        >
        <span
          style="background-color: #ffe4e4; color: #d76b59"
          class="status"
          v-if="detail.reviewed_status == 3"
          >审核不通过</span
        >
      </span>

      <el-button type="primary" style="width: 92px" size="medium" @click="back"
        >返回</el-button
      >
    </div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div style="padding: 0 20px">
          <span class="itemtitle">提交日期：</span>
          <span>{{ detail.update_time }}</span>
        </div>
        <div
          style="width: 100%; height: 1px; background: #e8e9f0; margin: 16px 0"
        ></div>
        <div style="padding: 0 20px">
          <div class="itemtitle">药房信息</div>
          <div class="infobox">
            <div>
              <span style="display: inline-block; width: 300px">
                <span class="gray">药房名称：</span>
                <span class="black">{{ detail.hospital_name }}</span>
              </span>
              <span>
                <span class="gray">药房类型：</span>
                <span class="black">{{ detail.org_type }}</span>
              </span>
            </div>
            <div style="margin: 20px 0">
              <span class="gray">纳税人识别号：</span>
              <span class="black">{{ detail.identification_number }}</span>
            </div>
            <div>
              <span class="gray">所在区域：</span>
              <span class="black">{{ detail.address }}</span>
            </div>
          </div>
          <div class="itemtitle">药品信息</div>
          <div>
            <div class="infobox" style="margin-bottom: 0px">
              <div style="margin-bottom: 20px">
                <span style="display: inline-block; width: 300px">
                  <span class="gray">药品名称：</span>
                  <span class="black">{{ detail.goods_name }}</span>
                </span>
                <span style="display: inline-block; width: 320px">
                  <span class="gray">类型：</span>
                  <span class="black" v-if="detail.goods_type == 1">中药</span>
                  <span class="black" v-if="detail.goods_type == 2"
                    >中成药</span
                  >
                  <span class="black" v-if="detail.goods_type == 3">西药</span>
                </span>
                <span>
                  <span class="gray">剂型：</span>
                  <span class="black">{{ detail.drug_type_name }}</span>
                </span>
              </div>
              <div style="margin-bottom: 20px">
                <span style="display: inline-block; width: 300px">
                  <span class="gray">通用名称：</span>
                  <span class="black">{{ detail.generic_name }}</span>
                </span>
                <span style="display: inline-block; width: 320px">
                  <span class="gray">药品厂家：</span>
                  <span class="black">{{ detail.productor }}</span>
                </span>
                <span>
                  <span class="gray">规格：</span>
                  <span v-if="detail.dosage_unit != 2"
                    >{{ detail.dosage_num }}g/{{
                      detail.dosage_unit_name
                    }}</span
                  >
                  <span v-else>{{ detail.dosage_num }}g</span>
                </span>
              </div>
              <div>
                <span style="display: inline-block; width: 300px">
                  <span class="gray">当量：</span>
                  <span class="black">{{ detail.conversion }}g</span>
                </span>
              </div>
            </div>
            <div class="pricebox">
              <span style="margin-right: 160px">
                <span class="gray">成本价(元)：</span>
                <span class="black">{{ detail.cost_price }}</span>
              </span>
              <span>
                <span class="gray">销售价(元)：</span>
                <span class="black">{{ detail.price }}</span>
              </span>
            </div>
          </div>

          <div style="margin-top: 20px">
            <div
              v-for="(item,index) in detail.edit_content"
              :key="index"
              style="color: red; padding: 10px 0"
            >
              <span>{{ item.name }}修改前:</span>
              <span>{{ item.value }}</span>
            </div>
          </div>

          <div style="margin-top: 40px" v-if="detail.reviewed_status == 1">
            <el-button
              plain
              @click="examine(3)"
              style="width: 100px"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('96') : false
              "
              >不通过</el-button
            >
            <el-button
              type="primary"
              @click="examine(2)"
              style="width: 100px"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('96') : false
              "
              >通过</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import platform from "../../../api/platform";
import axios from "../../../service/axios/axios";
import hospital from "../../../api/hospital";
import _ from "lodash";
export default {
  data() {
    return {
      business_license: "",
      drug_trade_license: "",
      gsp: "",
      id_card_face: "",
      id_card_side: "",
      detail: {},
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  methods: {
    //获取药品审核详情
    getReviewed() {
      let goods_id = this.$route.query.goods_id;
      hospital
        .getGoodsAuthInfo({ goods_id })
        .then((res) => {
          if (res.code == 0) {
            this.detail = res.data.info;
            let data = res.data.info;
            this.detail.update_time = platform.timestampToTime(
              this.detail.update_time
            );
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    //审核
    examine(status) {
      let goods_id = this.$route.query.goods_id;
      let auth_status = status;
      let text = "";
      if (status == 3) {
        text = "未通过";
      } else {
        text = "通过";
      }
      this.$confirm(`是否审核${text}？`, "审核", {
        closeOnClickModal: false,
        distinguishCancelAndClose: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          hospital.auditGoods({ goods_id, auth_status }).then((res) => {
            if (res.code == 0) {
              this.$message.success(`该药品审核${text}!`);
              this.back();
            }
          });
        })
        .catch();
    },
    back() {
      history.back();
    },
  },
  created() {
    this.getReviewed();
  },
};
</script>
<style lang="scss" scoped>
.container {
  width: 100%;
  padding: 24px 0;
  box-sizing: border-box;
  background: #ffffff;
  min-width: 1000px;
  text-align: left;
  min-height: calc(100vh - 140px);
}

.black {
  color: #000;
}
.gray {
  color: #666;
  display: inline-block;
  text-align: right;
  width: 100px;
}
.itemtitle {
  color: #333;
  font-weight: 600;
  margin-bottom: 12px;
}
.infobox {
  height: 100%;
  border: solid 1px #cfcece;
  padding: 20px;
  box-sizing: border-box;
  margin-bottom: 30px;
}
.imglist {
  padding-right: 40px;
  display: flex;
  justify-content: space-between;
  .imgitem {
    width: 200px;
    .imgbox {
      width: 200px;
      height: 140px;
      border: solid 1px #d6d6d6;
      padding: 10px;
      box-sizing: border-box;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .imgtext {
      color: #737982;
      font-weight: 600;
      margin-bottom: 8px;
    }
  }
}
.status {
  display: inline-block;
  border-radius: 2px;
  height: 20px;
  line-height: 20px;
  padding: 3px 8px;
  margin-left: 20px;
  font-size: 16px;
  font-weight: 400;
}
.pricebox {
  border: solid 1px #cfcece;
  height: 40px;
  line-height: 40px;
  border-top: 0px solid #fff;
  padding-left: 20px;
  box-sizing: border-box;
}
</style>
